module.exports = __webpack_public_path__ + "b3e3d23551a9ff64a84f2b12235ceb04.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/img/clouds.jpg
// module id = 636
// module chunks = 0